// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IAddFileResponse {
  /** Имя файла **/
  fileName: string;
  /** Идентификатор, указывается только если Result == success **/
  id?: string;
  /** Статус добавления **/
  result: EResult;
}
export enum EResult {
  'Success' = 'success',
  'Fail' = 'fail',
  'InvalidContent' = 'invalidContent',
  'NoContent' = 'noContent',
  'InvalidExtension' = 'invalidExtension',
}
